module.exports = __webpack_public_path__ + "static/media/Document_icon.1cea683a.svg";